// Экран 8 из ТЗ раздел 3.3: промокоды. Единственный сейчас рабочий тип (DiscountType.FREE_PERIOD)
// активирует пробную подписку напрямую, минуя оплату (см. app/api/routes/miniapp/promo.py — та же
// причина, по которой на экране 2 «Оформление подписки» нет поля под промокод). При успехе
// обновляем общий subscriptionStore — экраны «Моя подписка»/«Устройства» сразу увидят новую
// подписку без повторного похода на сервер.
import { useState, type FormEvent } from "react";
import { useTranslation } from "react-i18next";

import { ApiError, redeemPromo, type InstallPackage } from "../api/client";
import { useSubscriptionStore } from "../store/subscriptionStore";

export function PromoScreen() {
  const { t } = useTranslation();
  const { setSubscription } = useSubscriptionStore();
  const [code, setCode] = useState("");
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [installPackages, setInstallPackages] = useState<InstallPackage[] | null>(null);

  const handleSubmit = (event: FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    const trimmed = code.trim();
    if (!trimmed) return;
    setSubmitting(true);
    setError(null);
    setInstallPackages(null);
    redeemPromo(trimmed)
      .then(({ subscription, install_packages }) => {
        setSubscription(subscription);
        setInstallPackages(install_packages);
        setCode("");
      })
      .catch((err: unknown) => setError(err instanceof ApiError ? err.message : String(err)))
      .finally(() => setSubmitting(false));
  };

  return (
    <div>
      <h1>{t("promo_title")}</h1>
      {error && <p role="alert">{error}</p>}
      {installPackages && (
        <div>
          <p>{t("promo_success")}</p>
          {installPackages.length === 0 && <p>{t("devices_links_pending")}</p>}
          <ul>
            {installPackages.map((pkg) => (
              <li key={pkg.os}>
                <a href={pkg.url}>{pkg.os}</a>
              </li>
            ))}
          </ul>
        </div>
      )}
      <form onSubmit={handleSubmit}>
        <input
          value={code}
          onChange={(event) => setCode(event.target.value)}
          placeholder={t("promo_code_placeholder")}
        />
        <button type="submit" disabled={submitting || !code.trim()}>
          {submitting ? t("loading") : t("promo_submit")}
        </button>
      </form>
    </div>
  );
}
